import { createSelector } from 'reselect';

const selectLMSLearningPaths = (state: any) => state.lmsLearningPaths;

export const selectLMSLearningPathsCurrentItem = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.current
);

export const selectLMSLearningPathsListItems = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.list
);

export const selectLMSLearningPathsItemById = (itemId: any) =>
  createSelector(selectLMSLearningPathsListItems, (list) =>
    list.result.items.find((item: any) => item._id === itemId)
  );

export const selectLMSLearningPathsQueryItems = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.query
);

export const selectLMSLearningPathsCreatedItem = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.create
);

export const selectLMSLearningPathsUpdatedItem = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.update
);

export const selectLMSLearningPathsReadItem = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.read
);

export const selectLMSLearningPathsDeletedItem = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.delete
);

export const selectLMSLearningPathsSearchedItems = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.search
);

export const selectLMSLearningPathsItemsCount = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.count
);

export const selectLMSLearningPathsItemsFilter = createSelector(
  [selectLMSLearningPaths],
  (lmsLearningPaths) => lmsLearningPaths.filter
);
